import { __assign } from "tslib";
import { Table, styled } from '@mui/material';
export var StyledTable = styled(Table, {
    shouldForwardProp: function (prop) { return !['borderHeader', 'shadowHeader'].includes(String(prop)); },
})(function (_a) {
    var theme = _a.theme, borderHeader = _a.borderHeader, shadowHeader = _a.shadowHeader;
    return (__assign(__assign({}, (borderHeader && __assign({ th: {
            borderTop: "1px solid ".concat(theme.palette.greySecondary[100])
        } }, (shadowHeader && {
        th: {
            borderTop: "1px solid ".concat(theme.palette.greySecondary[100]),
            boxShadow: "4px 0 0px 0px rgb(255,255,255), -4px 0 12px 0px rgb(255,255,255), 0 2px 2px 0 rgba(0, 0, 0, 0.05)",
        }
    })))), (shadowHeader && __assign({ th: {
            boxShadow: "4px 0 0px 0px rgb(255,255,255), -4px 0 12px 0px rgb(255,255,255), 0 2px 2px 0 rgba(0, 0, 0, 0.05)",
        } }, (borderHeader && {
        th: {
            borderTop: "1px solid ".concat(theme.palette.greySecondary[100]),
            boxShadow: "4px 0 0px 0px rgb(255,255,255), -4px 0 12px 0px rgb(255,255,255), 0 2px 2px 0 rgba(0, 0, 0, 0.05)",
        }
    })))));
});
//# sourceMappingURL=styled.js.map